export default __webpack_public_path__ + "static/beacon-order-8c3dd8af1a358f8b2187cd2d778b1645.mp4";